import { toaster } from "@/components/ui/toaster";
import { getLegalOnboardingRequests } from "@/services/legal-onboarding.service";
import { getAxiosErrorMessage } from "@/utils/axios-error-message";
import { AxiosError } from "axios";
import { Dispatch, RefObject, SetStateAction } from "react";
import {
  GetLegalOnboardingRequestsFilters,
  LegalOnboardingListResponse,
} from "./legal-onboarding.schema";

export interface FetchLegalOnboardingRequestsHandlerProps {
  filters?: GetLegalOnboardingRequestsFilters;
  showLoad?: boolean;
  setLoading?: Dispatch<SetStateAction<boolean>>;
  setList?: Dispatch<SetStateAction<LegalOnboardingListResponse>>;
}

export const fetchLegalOnboardingRequestsHandler = async ({
  filters,
  showLoad = true,
  setLoading,
  setList,
}: FetchLegalOnboardingRequestsHandlerProps = {}) => {
  try {
    if (showLoad) setLoading?.(true);

    const response = await getLegalOnboardingRequests({
      ...filters,
      "P.Pagina": filters?.["P.Pagina"] ?? 1,
      "P.Records": filters?.["P.Records"] ?? 10,
    });

    setList?.(response);
    return response;
  } catch (error) {
    const errorObj = error as AxiosError;

    toaster.create({
      type: "error",
      title: getAxiosErrorMessage(
        errorObj,
        "No se pudieron obtener las solicitudes de onboarding jurídico.",
      ),
    });

    throw error;
  } finally {
    if (showLoad) setLoading?.(false);
  }
};

export interface LoadOptionsHandlerProps {
  timeoutRef: RefObject<NodeJS.Timeout | null>;
  inputValue: string;
  setLoading: Dispatch<SetStateAction<boolean>>;
  getOptions: (inputValue: string) => Promise<any[]>;
}

export const loadOptionsHandler = ({
  timeoutRef,
  inputValue,
  getOptions,
  setLoading,
}: LoadOptionsHandlerProps): Promise<any[]> => {
  return new Promise((resolve) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (inputValue.trim().length < 3) {
        resolve([]);
        return;
      }

      setLoading(true);
      const options = getOptions(inputValue);
      setLoading(false);
      resolve(options);
    }, 1000);
  });
};
